export default __webpack_public_path__ + "static/media/file.cfaa8102.svg";